import { env } from '@/env';

export const prefixCmsUrl = (url: string) => (url?.startsWith('http') ? url : `${env.NEXT_PUBLIC_CMS_API_BASE_URL.replace(/\/$/, '')}/${url?.replace(/^\//, '')}`);
